// ============================================================================
// todo-client-mod -- 动画 & 过渡常量
//
// 用于内联样式的动画配置，保持一致的动效体验。
// ============================================================================
import { transition } from './theme.js';
export const animations = {
    /** 列表项进入动画 */
    listItemEnter: {
        animation: 'todo-fade-in-up 0.25s ease forwards',
    },
    /** 弹窗进入 */
    modalEnter: {
        animation: 'todo-scale-in 0.2s ease forwards',
    },
    /** 退出动画 */
    exit: {
        animation: 'todo-fade-out 0.15s ease forwards',
    },
    /** 脉冲（用于加载/刷新） */
    pulse: {
        animation: 'todo-pulse 1.5s ease-in-out infinite',
    },
    /** 勾选动画 */
    checkPop: {
        animation: 'todo-pop 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
    },
    /** 摇晃（用于错误提示） */
    shake: {
        animation: 'todo-shake 0.4s ease',
    },
};
/** 全局动画关键帧（通过注入 <style> 标签生效） */
export const KEYFRAMES_CSS = `
@keyframes todo-fade-in-up {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes todo-fade-out {
  from { opacity: 1; }
  to { opacity: 0; }
}

@keyframes todo-scale-in {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes todo-pop {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

@keyframes todo-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes todo-shake {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-4px); }
  40%, 80% { transform: translateX(4px); }
}

@keyframes todo-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes todo-slide-down {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 通用工具类 */
.todo-btn-transition {
  transition: background-color ${transition.fast}, border-color ${transition.fast}, color ${transition.fast}, box-shadow ${transition.fast};
}
`;
/* -------------------------------------------------------------------------- */
/* 常用过渡样式工厂                                                           */
/* -------------------------------------------------------------------------- */
/** 悬停过渡效果 */
export function hoverTransition(style = {}) {
    return {
        ...style,
        transition: `background-color ${transition.fast}, border-color ${transition.fast}, color ${transition.fast}, box-shadow ${transition.fast}, transform ${transition.fast}`,
    };
}
/** 按钮基础样式 + 悬停态 */
export function buttonBase(overrides = {}) {
    return hoverTransition({
        cursor: 'pointer',
        fontFamily: 'inherit',
        outline: 'none',
        border: 'none',
        ...overrides,
    });
}
/** 输入框基础样式 */
export function inputBase(theme) {
    return {
        padding: '8px 12px',
        border: `1px solid ${theme.border.default}`,
        borderRadius: '6px',
        fontSize: '14px',
        outline: 'none',
        backgroundColor: theme.bg.tertiary,
        transition: `border-color ${transition.fast}, box-shadow ${transition.fast}`,
    };
}
//# sourceMappingURL=animations.js.map